export default "__VITE_ASSET__20f1c47d__"